import { render } from "./a_dab.vue?vue&type=template&id=95e27768"
import script from "./a_dab.vue?vue&type=script&lang=js"
export * from "./a_dab.vue?vue&type=script&lang=js"

import "./a_dab.vue?vue&type=style&index=0&id=95e27768&lang=less"
script.render = render

export default script